import BaseService from './baseService'
import EndPoints from '@/constants/dxApiEndpoints'
import RoimaticConfiguration, {
  CustomLabelTypeRequest
} from '@/types/roimaticConfigurations'

class RoimaticService extends BaseService {
  getRoimaticConfiguration = async (
    businessProfileId: number
  ): Promise<RoimaticConfiguration> => {
    const response = await this.apiClient.get<{ data: RoimaticConfiguration }>(
      EndPoints.RoimaticConfiguration(businessProfileId)
    )
    return response.data
  }
  patchRoimaticConfiguration = async (
    businessProfileId: number,
    patchData: Array<Object>
  ) => {
    const response = await this.apiClient.patch(
      EndPoints.RoimaticConfiguration(businessProfileId),
      patchData
    )
    return response
  }

  setCustomLabelTypes = async (
    businessProfileId: number,
    requests: CustomLabelTypeRequest[]
  ): Promise<void> => {
    if (!requests.length) return

    await this.apiClient.post(
      EndPoints.setCustomLabelTypes(businessProfileId),
      requests
    )
  }
}

export default RoimaticService
